export default __webpack_public_path__ + "locales/uk-UA/Common.json?hash=73b145a8d6e2f0ef11cefbf4cf7f9126";